import React from 'react';
import MenuButtonFilter from '@app/component/menu/MenuButtonFilter';
import ReviewsFilterInput from '@app/model/review/input/ReviewsFilterInput';
import Range from '@app/model/_common/Range';

type ReviewsRatingButtonFilterProps = {
	filter: ReviewsFilterInput;
	onFilter: (filter: ReviewsFilterInput) => void;
};

const ReviewsRatingButtonFilter = React.memo(
	function ReviewsRatingButtonFilter({ filter, onFilter }: ReviewsRatingButtonFilterProps) {

		const menuItems = [
			{
				name: 'All ratings',
				value: null,
			},
			{
				value: {
					from: 8.0,
					to: 10.0,
				},
				name: 'Positive ratings (8.0-10.0)',
			},
		];

		const onSelect = (value: Range | null | undefined) => {
			onFilter({
				...filter,
				rating: value,
			});
		};

		return <MenuButtonFilter menuItems={menuItems} selectedValue={filter.rating} onSelect={onSelect} />;
	},
);

export default ReviewsRatingButtonFilter;